import React from 'react'
import { ButtonGroup as ButtonGroupProps } from '@/payload-types'
import { CMSButton } from '../CMSButton'
import { ButtonAppearances, ButtonSizeOptions } from '@/cms/fields/button'

type ButtonGroupPropsType = {
  buttons: ButtonGroupProps | undefined
  fixedAppearance?: ButtonAppearances
  fixedSize?: ButtonSizeOptions
}

export const CMSButtonGroup: React.FC<ButtonGroupPropsType> = ({
  buttons,
  fixedAppearance,
  fixedSize,
}) => {
  return (buttons || []).map(({ button }, i) => {
    if (!button) return null
    return (
      <CMSButton
        key={i}
        {...button}
        appearance={fixedAppearance ?? button.appearance}
        size={fixedSize ?? button.size}
      />
    )
  })
}
